import styled from '@emotion/styled';
import Image from 'next/image';
import { useState } from 'react';
import { Apply, Complete, PreTest } from './step-pages';
import Button from '@/components/comm/Button';
import TitleWithDivider from '@/components/comm/TitleWithDivider';
import Stepper from '@/components/comm/stepper';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import nextDisImg from '@/public/images/img-btn-banner-next-arrow-disabled.svg';
import nextImg from '@/public/images/img-btn-banner-next-arrow.svg';
import prevDisImg from '@/public/images/img-btn-banner-prev-arrow-disabled.svg';
import prevImg from '@/public/images/img-btn-banner-prev-arrow.svg';

const testSteps = Object.freeze(['사전테스트', '시험 응시', '시험 종료']) as string[];

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const StepperContainer = styled.div`
position: absolute;
right: 0;
width: fit-content;
`;

const ButtonContainer = styled.div`
display: flex;
width: 92px;
justify-content: space-between;
@media  (max-width: ${breakpointMedium}) {
  max-height: 144px;
  align-self: flex-end;
}
`;

const ArrowButton = styled(Button)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0px 7px 10px ${colors.brightGrey3};

  :hover {
    background-color: ${colors.whiteGrey2};
  }

  :disabled {
    background-color: ${colors.white};
    opacity: 1
  }
`;

const ImgContainer = styled.div`
  display: grid;
  place-items: center;
`;

const TestSteps = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  return (
    <Container>
      <TitleWithDivider title="시험 진행 과정">
        <StepperContainer>
          <Stepper
            steps={testSteps}
            currentStep={currentStep}
            hideStepName
          />
        </StepperContainer>
        {currentStep === 1 && <PreTest />}
        {currentStep === 2 && <Apply />}
        {currentStep === 3 && <Complete />}
        <ButtonContainer>
          <ArrowButton
            styleType="white"
            disabled={currentStep === 1}
            onClick={handlePrev}
          >
            <ImgContainer>
              <Image src={currentStep === 1 ? prevDisImg : prevImg} alt="prev" />
            </ImgContainer>
          </ArrowButton>
          <ArrowButton
            styleType="white"
            disabled={currentStep === testSteps.length}
            onClick={handleNext}
          >
            <ImgContainer>
              <Image
                src={currentStep === testSteps.length ? nextDisImg : nextImg}
                alt="next"
              />
            </ImgContainer>
          </ArrowButton>
        </ButtonContainer>
      </TitleWithDivider>
    </Container>
  );
};

export default TestSteps;
